import { UntypedFormGroup, UntypedFormControl, Validators, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { ValidatorPatterns } from '../../../validators/validator-patterns';

export class UserForm extends UntypedFormGroup {
  constructor() {
    super({
      firstName: new UntypedFormControl(undefined, [Validators.required, Validators.pattern(ValidatorPatterns.onlyLetters)]),
      lastName: new UntypedFormControl(undefined, [Validators.required, Validators.pattern(ValidatorPatterns.onlyLetters)]),
      email: new UntypedFormControl(undefined),
    });
  }

  forAdd() {

    return this;
  }
}
